<template>
    <div :class="$style.wrapper">
        <table class="table table-sm table-striped mb-0">
            <thead>
                <tr>
                    <slot name="columns"></slot>
                </tr>
            </thead>

            <tbody>
                <slot></slot>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        columns: Array,
        data: Object,
    },
};
</script>

<style lang="scss" module>
.wrapper {
    margin-top: -3px;
    font-size: 0.9rem;
}
</style>
